// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css - Global styles for the application */

/* Base CSS Reset (Minimal) */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Layout - app-container is the outermost flex container */
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* background-color is now handled by muiTheme.palette.background.default in App.js main style */
}

/* page-content class is applied to the main element in App.js */
/* Its padding, margin-left, transition, and background-color are now set via inline styles in App.js using the theme */
.page-content {
  flex: 1 0 auto; /* Allows footer to stick to bottom if content is short */
  /* Example: if you need additional specific styles for page-content not covered by inline styles in App.js */
  /* width: 100%; */ /* This might be useful if not set by flexGrow */
}

/* auth-page class is applied to main for Login/Register in App.js */
/* Its display, alignItems, justifyContent, minHeight, and backgroundColor are set via inline styles in App.js */
.auth-page {
  /* Styles here would be additive to or override inline styles if more specific */
  /* For example, if Login/Register components need a max-width container within the centered page: */
  /* & > * { max-width: 400px; width: 100%; } */
}


/* Animations (can be kept if used elsewhere, or remove if not) */
@keyframes fadeIn பொதுவானது { /* Renamed to avoid conflict if animate.css is used differently */
  from {
    opacity: 0;
    transform: translateY(8px); /* Slightly less translation */
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.content-fade-in { /* Apply this class to page containers for a subtle entry animation */
  animation: fadeIn பொதுவானது 0.4s ease-out;
}


/* Utility classes (Review and keep only if necessary and not provided by MUI or theme) */
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-center {
  text-align: center;
}

.hover-elevate {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.hover-elevate:hover {
  transform: translateY(-3px); /* Subtle lift */
  /* Rely on MUI Card/Paper theme for hover box-shadow if possible */
  /* box-shadow: 0 6px 12px rgba(0,0,0,0.1); */
}

/* Specific component-like styles that might not be fully covered by MUI theme or are highly custom. */
/* Review these carefully. If they style MUI components, prefer theme overrides. */

/* Example: .status-badge - If MUI Chip is used, style Chip via theme. If custom, then keep. */
/* .status-badge { ... } */

/* Example: .signature-canvas - This is likely for a specific library. */
/* Ensure its styling is compatible with the new theme (e.g., border colors, background). */
.signature-canvas { /* Assuming this is for react-signature-canvas or similar */
  width: 100% !important; /* Important might be needed depending on library */
  height: 200px !important;
  /* Use theme variables for border and background if possible */
  /* border: 1px solid var(--mui-palette-divider); */
  /* background-color: var(--mui-palette-background-paper); */
  border-radius: var(--mui-shape-borderRadius); /* Use theme border radius */
}

.signature-container { /* Container for the signature pad */
  /* background-color: var(--mui-palette-background-default); */ /* Example */
  padding: 8px; /* theme.spacing(1) */
  border-radius: var(--mui-shape-borderRadius);
  /* border: 1px solid var(--mui-palette-divider); */
}


/* Print styles (Generally okay to keep) */
@media print {
  .no-print {
    display: none !important;
  }

  .page-content {
    padding: 0 !important; /* Remove padding for print */
    margin-left: 0 !important; /* Remove margin for print */
    background-color: #ffffff !important; /* Ensure white background for print */
  }

  body {
    background-color: #ffffff !important;
    color: #000000 !important; /* Ensure black text for print */
  }

  /* Hide navigation and footer for print */
  nav, footer {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD,6BAA6B;AAC7B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gGAAgG;AAClG;;AAEA,gEAAgE;AAChE,uHAAuH;AACvH;EACE,cAAc,EAAE,yDAAyD;EACzE,4GAA4G;EAC5G,iBAAiB,EAAE,gDAAgD;AACrE;;AAEA,oEAAoE;AACpE,gHAAgH;AAChH;EACE,gFAAgF;EAChF,mGAAmG;EACnG,6CAA6C;AAC/C;;;AAGA,iEAAiE;AACjE,8BAA8B,iEAAiE;EAC7F;IACE,UAAU;IACV,0BAA0B,EAAE,8BAA8B;EAC5D;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB,qEAAqE;EACtF,yCAAyC;AAC3C;;;AAGA,yFAAyF;AACzF;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,2BAA2B,EAAE,gBAAgB;EAC7C,kEAAkE;EAClE,4CAA4C;AAC9C;;AAEA,sGAAsG;AACtG,kFAAkF;;AAElF,8FAA8F;AAC9F,0BAA0B;;AAE1B,wEAAwE;AACxE,2FAA2F;AAC3F,oBAAoB,2DAA2D;EAC7E,sBAAsB,EAAE,mDAAmD;EAC3E,wBAAwB;EACxB,8DAA8D;EAC9D,kDAAkD;EAClD,2DAA2D;EAC3D,4CAA4C,EAAE,4BAA4B;AAC5E;;AAEA,uBAAuB,oCAAoC;EACzD,6DAA6D,EAAE,YAAY;EAC3E,YAAY,EAAE,qBAAqB;EACnC,4CAA4C;EAC5C,kDAAkD;AACpD;;;AAGA,0CAA0C;AAC1C;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB,EAAE,6BAA6B;IACpD,yBAAyB,EAAE,4BAA4B;IACvD,oCAAoC,EAAE,sCAAsC;EAC9E;;EAEA;IACE,oCAAoC;IACpC,yBAAyB,EAAE,gCAAgC;EAC7D;;EAEA,yCAAyC;EACzC;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* App.css - Global styles for the application */\n\n/* Base CSS Reset (Minimal) */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* Layout - app-container is the outermost flex container */\n.app-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  /* background-color is now handled by muiTheme.palette.background.default in App.js main style */\n}\n\n/* page-content class is applied to the main element in App.js */\n/* Its padding, margin-left, transition, and background-color are now set via inline styles in App.js using the theme */\n.page-content {\n  flex: 1 0 auto; /* Allows footer to stick to bottom if content is short */\n  /* Example: if you need additional specific styles for page-content not covered by inline styles in App.js */\n  /* width: 100%; */ /* This might be useful if not set by flexGrow */\n}\n\n/* auth-page class is applied to main for Login/Register in App.js */\n/* Its display, alignItems, justifyContent, minHeight, and backgroundColor are set via inline styles in App.js */\n.auth-page {\n  /* Styles here would be additive to or override inline styles if more specific */\n  /* For example, if Login/Register components need a max-width container within the centered page: */\n  /* & > * { max-width: 400px; width: 100%; } */\n}\n\n\n/* Animations (can be kept if used elsewhere, or remove if not) */\n@keyframes fadeIn பொதுவானது { /* Renamed to avoid conflict if animate.css is used differently */\n  from {\n    opacity: 0;\n    transform: translateY(8px); /* Slightly less translation */\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.content-fade-in { /* Apply this class to page containers for a subtle entry animation */\n  animation: fadeIn பொதுவானது 0.4s ease-out;\n}\n\n\n/* Utility classes (Review and keep only if necessary and not provided by MUI or theme) */\n.text-truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.hover-elevate {\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.hover-elevate:hover {\n  transform: translateY(-3px); /* Subtle lift */\n  /* Rely on MUI Card/Paper theme for hover box-shadow if possible */\n  /* box-shadow: 0 6px 12px rgba(0,0,0,0.1); */\n}\n\n/* Specific component-like styles that might not be fully covered by MUI theme or are highly custom. */\n/* Review these carefully. If they style MUI components, prefer theme overrides. */\n\n/* Example: .status-badge - If MUI Chip is used, style Chip via theme. If custom, then keep. */\n/* .status-badge { ... } */\n\n/* Example: .signature-canvas - This is likely for a specific library. */\n/* Ensure its styling is compatible with the new theme (e.g., border colors, background). */\n.signature-canvas { /* Assuming this is for react-signature-canvas or similar */\n  width: 100% !important; /* Important might be needed depending on library */\n  height: 200px !important;\n  /* Use theme variables for border and background if possible */\n  /* border: 1px solid var(--mui-palette-divider); */\n  /* background-color: var(--mui-palette-background-paper); */\n  border-radius: var(--mui-shape-borderRadius); /* Use theme border radius */\n}\n\n.signature-container { /* Container for the signature pad */\n  /* background-color: var(--mui-palette-background-default); */ /* Example */\n  padding: 8px; /* theme.spacing(1) */\n  border-radius: var(--mui-shape-borderRadius);\n  /* border: 1px solid var(--mui-palette-divider); */\n}\n\n\n/* Print styles (Generally okay to keep) */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n\n  .page-content {\n    padding: 0 !important; /* Remove padding for print */\n    margin-left: 0 !important; /* Remove margin for print */\n    background-color: #ffffff !important; /* Ensure white background for print */\n  }\n\n  body {\n    background-color: #ffffff !important;\n    color: #000000 !important; /* Ensure black text for print */\n  }\n\n  /* Hide navigation and footer for print */\n  nav, footer {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
